import { Button, Card, InputNumber, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { updateAdditionalWorkPlaceItem } from '../../../../../../contextRedux/AdditionalAct/AdditionalActModel';
import { RootState } from '../../../../../../store';
import { Column } from '../../../../../../utils/column';
import '../LaborTable/LaborTable.css';

const LaborTable: React.FC<any> = ({}) => {
  const isMobile = useMediaQuery({ query: '(max-width: 480px)' });
  const dispatch = useDispatch();
  const [laborTableData, setLaborTableData] = useState<any>([]);
  const addedDevices = useSelector((state: RootState) => state?.models?.additionalAct.contractWorkPlaceItems);

  useEffect(() => {
    const totalLabor = Number.parseFloat(
      addedDevices
        .reduce(
          (total, item) =>
            total +
            item.laborPrice *
              item.piece *
              (item.period === 'lunar'
                ? 12
                : item.period === 'trimestrial'
                ? 4
                : item.period === 'semestrial'
                ? 2
                : item.period === 'anual'
                ? 1
                : 1),
          0
        )
        .toFixed(2)
    );

    const totalProductsValue = Number.parseFloat(
      addedDevices.reduce((total, item) => {
        const totalPrice = item.price;
        return total + totalPrice;
      }, 0)
    );

    const percent = Number.parseFloat(((totalLabor / (totalLabor + totalProductsValue)) * 100).toFixed(2));
    const updatedLaborTableData = [
      {
        key: 'total',
        totalLabor: totalLabor,
        totalProductsValue: totalProductsValue,
        percent: percent >= 1 ? percent : 1,
        totalLaborAndProducts: totalLabor + totalProductsValue,
      },
    ];
    setLaborTableData(updatedLaborTableData);
  }, [addedDevices]);

  const columnsSecondTable: Column[] = [
    {
      title: 'Total Manopera',
      dataIndex: 'totalLabor',
      key: 'totalLabor',
      editable: true,
    },
    // {
    //   title: 'Total Valoare Produse',
    //   dataIndex: 'totalProductsValue',
    //   key: 'totalProductsValue',
    // },
    // {
    //   title: 'Procent Manopera Adaugata',
    //   dataIndex: 'percent',
    //   key: 'percent',
    // },
    // {
    //   title: 'Total Manopera + Produse',
    //   dataIndex: 'totalLaborAndProducts',
    //   key: 'totalLaborAndProducts',
    // },
  ];

  const onChangeTotalLabor = (value: number) => {
    const updatedData = [...laborTableData];
    updatedData[0].totalLabor = Number.parseFloat(value.toFixed(2));

    setLaborTableData(updatedData);
  };

  const handleTotalLaborChange = () => {
    const totalLabor = Number.parseFloat(
      addedDevices
        .reduce(
          (total, item) =>
            total +
            item.laborPrice *
              (item.period === 'lunar'
                ? 12
                : item.period === 'trimestrial'
                ? 4
                : item.period === 'semestrial'
                ? 2
                : item.period === 'anual'
                ? 1
                : 1),
          0
        )
        .toFixed(2)
    );
    const totalProductsValue = Number.parseFloat(
      addedDevices
        .reduce((total, item) => {
          const totalPrice = item.price;
          return total + totalPrice;
        }, 0)
        .toFixed(2)
    );

    const factor = Number.parseFloat(
      (
        1 +
        (laborTableData[0].totalLabor + totalProductsValue - (totalLabor + totalProductsValue)) / totalLabor
      ).toFixed(2)
    );

    const updatedTable = addedDevices.map((item) => {
      // Create a new object to avoid mutating the original item
      let newItem = { ...item };

      if (newItem.unitMeasure === 'hour') {
        newItem.laborPriceOnHour =
          Number.parseFloat(((newItem.laborPrice / newItem.piece) * factor).toFixed(2)) >= 1
            ? Number.parseFloat(((newItem.laborPrice / newItem.piece) * factor).toFixed(2))
            : 1;
        newItem.laborPrice = Number.parseFloat((newItem.laborPriceOnHour * newItem.piece).toFixed(2));
      } else {
        // Ensure to create a new device object to avoid mutations
        newItem.device = { ...newItem.device };
        newItem.device.laborPriceSM =
          newItem.laborPrice / newItem.piece > newItem.device.laborPriceSM
            ? Number.parseFloat(((newItem.laborPrice / newItem.piece) * factor).toFixed(2)) >= 1
              ? Number.parseFloat(((newItem.laborPrice / newItem.piece) * factor).toFixed(2))
              : 1
            : Number.parseFloat((newItem.device.laborPriceSM * factor).toFixed(2)) >= 1
            ? Number.parseFloat((newItem.device.laborPriceSM * factor).toFixed(2))
            : 1;

        newItem.laborPrice = Number.parseFloat((newItem.device.laborPriceSM * newItem.piece).toFixed(2));
      }
      return newItem;
    });

    updatedTable.map((ut: any) => {
      dispatch(
        updateAdditionalWorkPlaceItem({
          index: addedDevices.findIndex(
            (item: any) => item.deviceTypeId === ut.deviceTypeId && item.workPlaceId === ut.workPlaceId
          ),
          updates: ut,
        })
      );
    });
  };

  const renderColumn = (column: any, _text: string, record: any) => {
    const value = Array.isArray(column.dataIndex)
      ? column.dataIndex.reduce((acc: any, key: any) => acc[key], record)
      : record[column.dataIndex];

    if (column.editable) {
      return (
        <>
          {column.dataIndex === 'totalLabor' && (
            <div className='input-button-container-SM'>
              <InputNumber
                min={1}
                value={value}
                onChange={(value) => onChangeTotalLabor(value)}
                className='totalLabor-input-SM'
              />
              <Button
                className='totalLabor-applyBtn-SM'
                onClick={() => handleTotalLaborChange()} // Open modal
              >
                Aplica
              </Button>
            </div>
          )}
        </>
      );
    }
    return value;
  };

  //mobile view
  const renderTotalLabor = () => (
    <Card className='labor-table-data-total-SM'>
      <strong>Total Manopera</strong>
      <div className='labor-table-data-container-SM'>
        <InputNumber
          min={1}
          value={laborTableData[0]?.totalLabor}
          onChange={(value) => onChangeTotalLabor(value)}
          className='totalLabor-input-SM'
        />
        <Button className='totalLabor-applyBtn-SM' onClick={handleTotalLaborChange}>
          Aplica
        </Button>
      </div>
    </Card>
  );

  return (
    <div>
      {isMobile ? (
        renderTotalLabor()
      ) : (
        <div>
          <Table
            rowClassName={'table-background-color'}
            dataSource={laborTableData}
            key={'id1'}
            rowHoverable={false}
            columns={columnsSecondTable?.map((column, index) => ({
              ...column,
              key: index,
              render: column.render || ((text, record) => renderColumn(column, text, record)),
            }))}
            pagination={false}
          />
        </div>
      )}
    </div>
  );
};

export default LaborTable;
